
import Teleport from 'vue2-teleport'
import { loadSectionTranslations } from '../../i18n-setup'
import isEmpty from 'lodash/isEmpty'
import RxDisclaimerTooltip from './rx-disclaimer-tooltip.vue'
import SghFileUploader from '@components/file-uploader/file-uploader.vue'
import SghRxPrescriptionModal from '@components/ui-components/rx-manual-input-prescription-modal.vue'
import { createNamespacedHelpers } from 'vuex'
import wcs from '@libs/wcs'
import { createGuestUser } from '@api/account'
import { prescriptionFileUpload } from '@libs/wcs/checkout'
import {
  ACTION_PRESCRIPTION_CART_ITEM_DATA_UPDATE,
  ACTION_PRESCRIPTION_DATA_LOADING,
  ACTION_PRESCRIPTION_DATA_RESET,
  ACTION_PRESCRIPTION_DATA_UPDATED,
} from '@store/actions/prescription'
import { ACTION_TOGGLE_POPUP_ID } from '@store/actions/ui'
import {deletePrescription, getPrescription} from '@api/rx'
import {clearPrescriptionInStorage, getPrescriptionFlow, parsePrescriptionToRxConfigurator, savePrescriptionInStorage} from '@libs/wcs/prescription'
const { mapGetters: mapGettersPrescription, mapActions: mapActionsPrescription } =
  createNamespacedHelpers('prescription')
const { mapActions: mapActionsUi, mapGetters: mapGettersUi } = createNamespacedHelpers('ui')
export default {
  name: 'RxFileDisclaimerWidget',
  components: {SghRxPrescriptionModal, SghFileUploader, RxDisclaimerTooltip, Teleport },
  props: {
    prescriptionId: {
      type: String,
      default: '',
    },
    orderItem:{
      type: String,
      default: '',
    },
    orderItemId: {
      type: String,
      default: '',
    },
    orderId: {
      type: String,
      default: '',
    },
    orderItemUpc: {
      type: String,
      default: '',
    },
    catEntryId: {
      type: String,
      default: '',
    },
    orderItemUrl: {
      type: String,
      default: '',
    },
    lensOrderId: {
      type: String,
      default: '',
    },
    lensUpc: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    prescriptionFileValid: true,
    ariaLiveMessage: '',
  }),
  computed: {
    ...mapGettersUi(['popups']),
    ...mapGettersPrescription([
      'prescriptionData',
      'prescriptionFileExtensions',
      'prescriptionMaxFileSize',
      'prescriptionFileName',
      'prescriptionLoading',
    ]),
    acceptedFileExtensions() {
      const extensionSuffixMap = {
        png: 'image/png',
        jpeg: 'image/jpeg',
        jpg: 'image/jpeg',
        gif: 'image/gif',
        tiff: 'image/tiff',
        bmp: 'image/bmp',
        pdf: 'application/pdf',
        word: 'application/msword',
      }
      return this.prescriptionFileExtensions?.map(ext => extensionSuffixMap[ext])?.join(',')
    },
    prescriptionDataMissing() {
      return !this.prescriptionData?.prescriptionId
    },
    prescriptionFileMissing() {
      return isEmpty(this.prescriptionData?.fileName)
    },
    isSuccess() {
      return this.isManualInputFlow
        ? !this.prescriptionDataMissing
        : !this.prescriptionFileMissing && !this.prescriptionDataMissing
    },
    isWarning() {
      return this.isManualInputFlow
        ? this.prescriptionDataMissing
        : this.prescriptionFileMissing || this.prescriptionDataMissing
    },
    isError() {
      return this.isTYP && this.prescriptionDataMissing
    },
    isManualInputFlow() {
      return this.prescriptionData?.prescriptionFlow === 'MANUAL'
    },
    isUploadFlow() {
      return this.prescriptionData?.prescriptionFlow === 'UPLOAD'
    },
    isTYP() {
      return wcs.isTYP()
    },
    isCheckout() {
      return wcs.isDelivery() || wcs.isPayment()
    },
    showUploadPrescriptionWarning() {
      return (
        !this.isCheckout &&
        !this.showInvalidFileWarning &&
        (this.prescriptionDataMissing || this.prescriptionFileMissing)
      )
    },
    showDetailsAction() {
      return this.isSuccess && (this.isManualInputFlow || (this.isUploadFlow && !wcs.isCart()))
    },
    showFileName() {
      return this.prescriptionFileName && wcs.isCart()
    },
    showChangeDeleteActions() {
      return !isEmpty(this.prescriptionFileName) && wcs.isCart()
    },
    showUploadNowAction() {
      return (
        this.prescriptionFileMissing &&
        !this.showInvalidFileWarning &&
        !this.isCheckout &&
        this.prescriptionDataMissing
      ) || (this.isError && this.isTYP && this.showInvalidFileWarning)
    },
    showInvalidFileWarning() {
      return !this.prescriptionFileValid
    },
    title() {
      if (this.isSuccess) {
        return this.isManualInputFlow
          ? this.$t('prescriptionEnteredTitle')
          : this.$t('prescriptionUploadedTitle')
      }
      if (this.isError) {
        return this.$t('missingPrescriptionErrorTitle')
      }
      return this.$t('missingPrescriptionTitle')
    },
    openPrescriptionDetails() {
      return this.popups['rxManualPrescription']?.open
    },
    detailsCtaElementId() {
      if(this.isTYP ) {
        return 'Order_ViewPrescription'
      } else if (this.isCheckout) {
        return 'OrderSummary_ViewPrescription'
      } else {
        return 'Prod_ViewPrescription'
      }
    },
    uploadCtaElementId() {
      return this.isCheckout || this.isTYP ? 'Order_AddPrescription' : 'Prod_AddPrescription'
    },
  },
  async mounted() {
    await loadSectionTranslations('rx')
    await this.updatePrescriptionCartItemData({
      orderItemId: this.orderItemId,
      productUPC: this.orderItemUpc,
      catEntryId: this.catEntryId,
      orderItemUrl: this.orderItemUrl,
      lensUPC: this.lensUpc,
    })
    if(this.prescriptionDataMissing && this.prescriptionId) await this.getUpdatePrescriptionData(this.prescriptionId)
  },
  methods: {
    isEmpty,
    ...mapActionsUi({
      togglePopup: ACTION_TOGGLE_POPUP_ID,
    }),
    ...mapActionsPrescription({
      updatePrescription: ACTION_PRESCRIPTION_DATA_UPDATED,
      updatePrescriptionCartItemData: ACTION_PRESCRIPTION_CART_ITEM_DATA_UPDATE,
      setPrescriptionDataLoading: ACTION_PRESCRIPTION_DATA_LOADING,
      resetPrescription: ACTION_PRESCRIPTION_DATA_RESET,
    }),
    async togglePrescriptionDetailsPopup() {
      await this.togglePopup({
        popupId: 'rxManualPrescription',
      })
    },
    async getUpdatePrescriptionData(prescriptionId) {
      const { storeId } = wcs.getStoreConfig()
      const updatedPrescription = await getPrescription({
        storeId,
        prescriptionId,
      })
      
      if(updatedPrescription?.data) {
        updatedPrescription.data.prescriptionFlow = getPrescriptionFlow(updatedPrescription.data)
        savePrescriptionInStorage(parsePrescriptionToRxConfigurator(updatedPrescription.data))
      }

      await this.updatePrescription(updatedPrescription?.data)
    },
    async upload(file) {
      const { storeId } = wcs.getStoreConfig()
      await this.setPrescriptionDataLoading(true)
      const userId = window.constants?.ajaxParams?.userId
      if (!userId || userId === '-1002') {
        await createGuestUser(storeId)
      }
      await prescriptionFileUpload({
        payload: {
          fileName: file?.name,
          fileData: file?.fileData,
          userId: parseInt(userId),
          orderId: parseInt(this.orderId),
          storeId,
        },
        store: this.$store,
        prescriptionFileUploadCallback: async response => {
          const { prescriptionDetails } = response || {}
          if (!!prescriptionDetails) {
            await this.getUpdatePrescriptionData(prescriptionDetails?.prescriptionId)
          }
        },
      }).catch(async error => {
        console.error('Error uploading file:', error)
        await this.setPrescriptionDataLoading(false)
      })
    },
    announceAriaMessage(msg) {
      this.ariaLiveMessage = ''
      this.$nextTick(() => {
        this.ariaLiveMessage = msg
        this.$refs.ariaLiveRegion?.focus?.()
      })
    },
    async handleFile(file) {
      this.prescriptionFileValid = file?.valid
      if (!this.prescriptionFileValid) {
        await this.updatePrescription({
          fileName: file?.name,
          fileData: null,
        })
        this.announceAriaMessage(this.$t('fileNotSupportedMessage'))
      } else {
        await this.upload(file)
        this.announceAriaMessage(this.$t('prescriptionUploadedTitle'))
      }
    },
    async handleFileDeletion() {
      await this.reset()
      this.announceAriaMessage(this.$t('prescriptionDeletedMessage'))
    },
    async reset() {
      await this.resetPrescription()
      this.prescriptionFileValid = true
      deletePrescription({
        storeId: wcs.getStoreConfig().storeId,
        lensOrderItemId: parseFloat(this.lensOrderId),
      }).then(() => {
        clearPrescriptionInStorage()
      })
    },
  },
}
